import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { EyeIcon } from "../../../assets/icons";
import UseContext from "../../../hooks/useContext";
import { dateWordShort } from "../../../helper/helper";
import TableCell from "./TableCell";
import TableRow from "./TableRow";

const COLUMN_RENDERERS = {
  group: (company) => company.bigAccounts?.join(', ') || '',
  createdAt: (company) => (company.createdAt ? dateWordShort(new Date(company.createdAt)) : '-'),
  siret: (company) => company.siret || '-',
  location: (company) => company.department || '-',
};

const Tbodycompany = ({ champsBody, activeColumns = ['group', 'createdAt'] }) => {
    const { setObjID, setSlideOverShow, setSlideOverType } = UseContext();
    const navigate = useNavigate();
    const location = useLocation();
    const [selectedId, setSelectedId] = useState(null);

    const openCompanyInfo = (id) => {
        navigate('/company?idCompany=' + id);
    };

    useEffect(() => {
        const id = new URLSearchParams(location.search).get('idCompany');
        setSelectedId(id);
        if (id) {
            setObjID(id);
            setSlideOverType('get_company');
            setSlideOverShow(true);
        }
    }, [location.search, setObjID, setSlideOverShow, setSlideOverType]);

    return (
        <>
            {champsBody?.map((company) => (
                <TableRow
                    key={company._id}
                    itemId={company._id}
                    selectedId={selectedId}
                    onClick={openCompanyInfo}
                >
                    <TableCell position="first" columnIndex={0}>
                        {company.name_commercial}
                    </TableCell>
                    {activeColumns.map((key, idx) => (
                        <TableCell key={key} columnIndex={idx + 1}>
                            {COLUMN_RENDERERS[key] ? COLUMN_RENDERERS[key](company) : '-'}
                        </TableCell>
                    ))}
                    <TableCell
                        position="last"
                        hasButton
                        buttonOnClick={(e) => {
                            e.stopPropagation();
                            openCompanyInfo(company._id);
                        }}
                        buttonContent={<EyeIcon wh={20} color={'#374151'} />}
                    />
                </TableRow>
            ))}
        </>
    );
};

export default Tbodycompany;
